import React from 'react';
import { ApiButton } from 'web-library';
import { ButtonVariant } from 'web-library/stories/atom/Button/Button';
import { PaymentMethod } from './PaymentButton';

interface PaymentButtonProps {
  buttonClassName?: string;
  onClickPaymentButton: (callback: () => void) => void;
  disabled?: boolean;
  buttonText?: string;
  fullWidth?: boolean;
  buttonVariant?: ButtonVariant;
  setStateHandler: {
    setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>;
    setIsPaymentModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setSelectedPaymentMethod: React.Dispatch<React.SetStateAction<PaymentMethod | null>>;
  };
  isLoading?: boolean;
}

const PaymentApiButton = ({
  buttonClassName,
  onClickPaymentButton,
  disabled,
  buttonText,
  fullWidth,
  buttonVariant,
  setStateHandler,
  isLoading,
}: PaymentButtonProps) => {
  const { setIsDisabled, setIsPaymentModalOpen, setSelectedPaymentMethod } = setStateHandler;
  return (
    <ApiButton
      id="button-paymentButton-proceedToPayment"
      fullWidth={fullWidth}
      status={isLoading ? 'loading' : 'idle'}
      variant={buttonVariant}
      className={buttonClassName}
      onClick={() => {
        setIsDisabled(false);
        const onClickPaymentCallback = () => {
          setIsPaymentModalOpen(true);
          setSelectedPaymentMethod(null);
        };
        onClickPaymentButton(onClickPaymentCallback);
      }}
      disabled={disabled}
    >
      {buttonText || 'Proceed to Payment'}
    </ApiButton>
  );
};

export default PaymentApiButton;
